import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";

interface DateRangeFilterProps {
  from: Dayjs | null;
  to: Dayjs | null;
  onFromChange: (value: Dayjs | null) => void;
  onToChange: (value: Dayjs | null) => void;
}

const DateRangeFilter = ({
  from,
  to,
  onFromChange,
  onToChange,
}: DateRangeFilterProps) => {
  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      <DatePicker
        label="Created from"
        value={from}
        onChange={onFromChange}
        maxDate={to ?? undefined}
        slotProps={{
          textField: { size: "small", sx: { width: 170 } },
        }}
      />
      <DatePicker
        label="Created to"
        value={to}
        onChange={onToChange}
        minDate={from ?? undefined}
        slotProps={{
          textField: { size: "small", sx: { width: 170 } },
        }}
      />
    </Box>
  );
};

export default DateRangeFilter;
